module.exports = __webpack_public_path__ + "home/img/headphone.0a839e80.svg";